/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Skoltend API - Hong Kong school tender platform
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  Category,
  CheckoutSessionResponse,
  CreateCheckoutBody,
  EmailBroadcastBatchInput,
  EmailBroadcastEnvelope,
  FeaturedTendersResponse,
  GetRecentTendersParams,
  GuideArticleInput,
  HealthStatus,
  ListTendersParams,
  MemberProfile,
  NotificationEmailChangeInput,
  NotificationEmailOtpSent,
  NotificationEmailVerifyInput,
  NotificationPreferences,
  PortalSessionResponse,
  TelegramBindLink,
  TelegramBotUsernameResponse,
  TelegramWidgetAuthData,
  TenderAirJobResult,
  TenderDetail,
  TenderListResponse,
  TenderStats,
  TenderSummary,
  UpdateNotificationPreferencesBody,
  UpdateProfileBody,
  WhatsAppRegisterInput,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Create an article with optional verified editorial metadata
 */
export const getCreateGuideArticleUrl = () => {
  return `/api/admin/guides`;
};

export const createGuideArticle = async (
  guideArticleInput: GuideArticleInput,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getCreateGuideArticleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(guideArticleInput),
  });
};

export const getCreateGuideArticleMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGuideArticle>>,
    TError,
    { data: BodyType<GuideArticleInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGuideArticle>>,
  TError,
  { data: BodyType<GuideArticleInput> },
  TContext
> => {
  const mutationKey = ["createGuideArticle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGuideArticle>>,
    { data: BodyType<GuideArticleInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createGuideArticle(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGuideArticleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGuideArticle>>
>;
export type CreateGuideArticleMutationBody = BodyType<GuideArticleInput>;
export type CreateGuideArticleMutationError = ErrorType<void>;

/**
 * @summary Create an article with optional verified editorial metadata
 */
export const useCreateGuideArticle = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGuideArticle>>,
    TError,
    { data: BodyType<GuideArticleInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGuideArticle>>,
  TError,
  { data: BodyType<GuideArticleInput> },
  TContext
> => {
  return useMutation(getCreateGuideArticleMutationOptions(options));
};

/**
 * @summary Update an article and its editorial metadata
 */
export const getUpdateGuideArticleUrl = (id: number) => {
  return `/api/admin/guides/${id}`;
};

export const updateGuideArticle = async (
  id: number,
  guideArticleInput: GuideArticleInput,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getUpdateGuideArticleUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(guideArticleInput),
  });
};

export const getUpdateGuideArticleMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGuideArticle>>,
    TError,
    { id: number; data: BodyType<GuideArticleInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGuideArticle>>,
  TError,
  { id: number; data: BodyType<GuideArticleInput> },
  TContext
> => {
  const mutationKey = ["updateGuideArticle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGuideArticle>>,
    { id: number; data: BodyType<GuideArticleInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGuideArticle(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGuideArticleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGuideArticle>>
>;
export type UpdateGuideArticleMutationBody = BodyType<GuideArticleInput>;
export type UpdateGuideArticleMutationError = ErrorType<void>;

/**
 * @summary Update an article and its editorial metadata
 */
export const useUpdateGuideArticle = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGuideArticle>>,
    TError,
    { id: number; data: BodyType<GuideArticleInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGuideArticle>>,
  TError,
  { id: number; data: BodyType<GuideArticleInput> },
  TContext
> => {
  return useMutation(getUpdateGuideArticleMutationOptions(options));
};

/**
 * @summary Read today's saved email broadcast progress
 */
export const getGetDailyEmailBroadcastUrl = () => {
  return `/api/admin/email-broadcast`;
};

export const getDailyEmailBroadcast = async (
  options?: RequestInit,
): Promise<EmailBroadcastEnvelope> => {
  return customFetch<EmailBroadcastEnvelope>(getGetDailyEmailBroadcastUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDailyEmailBroadcastQueryKey = () => {
  return [`/api/admin/email-broadcast`] as const;
};

export const getGetDailyEmailBroadcastQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyEmailBroadcast>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDailyEmailBroadcast>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyEmailBroadcastQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyEmailBroadcast>>
  > = ({ signal }) => getDailyEmailBroadcast({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyEmailBroadcast>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDailyEmailBroadcastQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyEmailBroadcast>>
>;
export type GetDailyEmailBroadcastQueryError = ErrorType<unknown>;

/**
 * @summary Read today's saved email broadcast progress
 */

export function useGetDailyEmailBroadcast<
  TData = Awaited<ReturnType<typeof getDailyEmailBroadcast>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDailyEmailBroadcast>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDailyEmailBroadcastQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create or resume the unique Hong Kong daily broadcast
 */
export const getCreateDailyEmailBroadcastUrl = () => {
  return `/api/admin/email-broadcast`;
};

export const createDailyEmailBroadcast = async (
  options?: RequestInit,
): Promise<EmailBroadcastEnvelope> => {
  return customFetch<EmailBroadcastEnvelope>(
    getCreateDailyEmailBroadcastUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCreateDailyEmailBroadcastMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDailyEmailBroadcast>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDailyEmailBroadcast>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["createDailyEmailBroadcast"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDailyEmailBroadcast>>,
    void
  > = () => {
    return createDailyEmailBroadcast(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDailyEmailBroadcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDailyEmailBroadcast>>
>;

export type CreateDailyEmailBroadcastMutationError = ErrorType<unknown>;

/**
 * @summary Create or resume the unique Hong Kong daily broadcast
 */
export const useCreateDailyEmailBroadcast = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDailyEmailBroadcast>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDailyEmailBroadcast>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCreateDailyEmailBroadcastMutationOptions(options));
};

/**
 * @summary Process a bounded batch with durable duplicate protection
 */
export const getProcessDailyEmailBroadcastUrl = () => {
  return `/api/admin/email-broadcast/batch`;
};

export const processDailyEmailBroadcast = async (
  emailBroadcastBatchInput: EmailBroadcastBatchInput,
  options?: RequestInit,
): Promise<EmailBroadcastEnvelope> => {
  return customFetch<EmailBroadcastEnvelope>(
    getProcessDailyEmailBroadcastUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(emailBroadcastBatchInput),
    },
  );
};

export const getProcessDailyEmailBroadcastMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processDailyEmailBroadcast>>,
    TError,
    { data: BodyType<EmailBroadcastBatchInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processDailyEmailBroadcast>>,
  TError,
  { data: BodyType<EmailBroadcastBatchInput> },
  TContext
> => {
  const mutationKey = ["processDailyEmailBroadcast"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processDailyEmailBroadcast>>,
    { data: BodyType<EmailBroadcastBatchInput> }
  > = (props) => {
    const { data } = props ?? {};

    return processDailyEmailBroadcast(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessDailyEmailBroadcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof processDailyEmailBroadcast>>
>;
export type ProcessDailyEmailBroadcastMutationBody =
  BodyType<EmailBroadcastBatchInput>;
export type ProcessDailyEmailBroadcastMutationError = ErrorType<void>;

/**
 * @summary Process a bounded batch with durable duplicate protection
 */
export const useProcessDailyEmailBroadcast = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processDailyEmailBroadcast>>,
    TError,
    { data: BodyType<EmailBroadcastBatchInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof processDailyEmailBroadcast>>,
  TError,
  { data: BodyType<EmailBroadcastBatchInput> },
  TContext
> => {
  return useMutation(getProcessDailyEmailBroadcastMutationOptions(options));
};

/**
 * @summary Record Tender Air homepage schools for the current Hong Kong three-hour slot
 */
export const getRunTenderAirJobUrl = () => {
  return `/api/jobs/tender-air`;
};

export const runTenderAirJob = async (
  options?: RequestInit,
): Promise<TenderAirJobResult> => {
  return customFetch<TenderAirJobResult>(getRunTenderAirJobUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRunTenderAirJobMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runTenderAirJob>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runTenderAirJob>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["runTenderAirJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runTenderAirJob>>,
    void
  > = () => {
    return runTenderAirJob(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunTenderAirJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof runTenderAirJob>>
>;

export type RunTenderAirJobMutationError = ErrorType<void>;

/**
 * @summary Record Tender Air homepage schools for the current Hong Kong three-hour slot
 */
export const useRunTenderAirJob = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runTenderAirJob>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runTenderAirJob>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRunTenderAirJobMutationOptions(options));
};

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns paginated list of tenders with optional filters
 * @summary List tenders
 */
export const getListTendersUrl = (params?: ListTendersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/tenders?${stringifiedParams}`
    : `/api/tenders`;
};

export const listTenders = async (
  params?: ListTendersParams,
  options?: RequestInit,
): Promise<TenderListResponse> => {
  return customFetch<TenderListResponse>(getListTendersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTendersQueryKey = (params?: ListTendersParams) => {
  return [`/api/tenders`, ...(params ? [params] : [])] as const;
};

export const getListTendersQueryOptions = <
  TData = Awaited<ReturnType<typeof listTenders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTendersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTenders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTendersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenders>>> = ({
    signal,
  }) => listTenders(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTenders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTendersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTenders>>
>;
export type ListTendersQueryError = ErrorType<unknown>;

/**
 * @summary List tenders
 */

export function useListTenders<
  TData = Awaited<ReturnType<typeof listTenders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTendersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTenders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTendersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns full tender detail. School name and details only visible for paid members.
 * @summary Get tender detail
 */
export const getGetTenderUrl = (id: number) => {
  return `/api/tenders/${id}`;
};

export const getTender = async (
  id: number,
  options?: RequestInit,
): Promise<TenderDetail> => {
  return customFetch<TenderDetail>(getGetTenderUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTenderQueryKey = (id: number) => {
  return [`/api/tenders/${id}`] as const;
};

export const getGetTenderQueryOptions = <
  TData = Awaited<ReturnType<typeof getTender>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTender>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTenderQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTender>>> = ({
    signal,
  }) => getTender(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTender>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetTenderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTender>>
>;
export type GetTenderQueryError = ErrorType<void>;

/**
 * @summary Get tender detail
 */

export function useGetTender<
  TData = Awaited<ReturnType<typeof getTender>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTender>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTenderQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns counts of tenders by category, district, and status
 * @summary Get tender statistics
 */
export const getGetTenderStatsUrl = () => {
  return `/api/tenders/stats`;
};

export const getTenderStats = async (
  options?: RequestInit,
): Promise<TenderStats> => {
  return customFetch<TenderStats>(getGetTenderStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetTenderStatsQueryKey = () => {
  return [`/api/tenders/stats`] as const;
};

export const getGetTenderStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTenderStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTenderStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTenderStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenderStats>>> = ({
    signal,
  }) => getTenderStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTenderStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTenderStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTenderStats>>
>;
export type GetTenderStatsQueryError = ErrorType<unknown>;

/**
 * @summary Get tender statistics
 */

export function useGetTenderStats<
  TData = Awaited<ReturnType<typeof getTenderStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTenderStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTenderStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all tender categories with counts
 * @summary List all categories
 */
export const getListCategoriesUrl = () => {
  return `/api/categories`;
};

export const listCategories = async (
  options?: RequestInit,
): Promise<Category[]> => {
  return customFetch<Category[]>(getListCategoriesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCategoriesQueryKey = () => {
  return [`/api/categories`] as const;
};

export const getListCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCategories>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCategories>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCategoriesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCategories>>> = ({
    signal,
  }) => listCategories({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCategories>>
>;
export type ListCategoriesQueryError = ErrorType<unknown>;

/**
 * @summary List all categories
 */

export function useListCategories<
  TData = Awaited<ReturnType<typeof listCategories>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCategories>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCategoriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the current authenticated user's profile and membership status
 * @summary Get current user profile
 */
export const getGetMyProfileUrl = () => {
  return `/api/members/me`;
};

export const getMyProfile = async (
  options?: RequestInit,
): Promise<MemberProfile> => {
  return customFetch<MemberProfile>(getGetMyProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyProfileQueryKey = () => {
  return [`/api/members/me`] as const;
};

export const getGetMyProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProfile>>> = ({
    signal,
  }) => getMyProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyProfile>>
>;
export type GetMyProfileQueryError = ErrorType<void>;

/**
 * @summary Get current user profile
 */

export function useGetMyProfile<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update WhatsApp ID, Telegram ID, and other profile fields
 * @summary Update current user profile
 */
export const getUpdateMyProfileUrl = () => {
  return `/api/members/me`;
};

export const updateMyProfile = async (
  updateProfileBody: UpdateProfileBody,
  options?: RequestInit,
): Promise<MemberProfile> => {
  return customFetch<MemberProfile>(getUpdateMyProfileUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateProfileBody),
  });
};

export const getUpdateMyProfileMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyProfile>>,
    TError,
    { data: BodyType<UpdateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyProfile>>,
  TError,
  { data: BodyType<UpdateProfileBody> },
  TContext
> => {
  const mutationKey = ["updateMyProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyProfile>>,
    { data: BodyType<UpdateProfileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyProfile>>
>;
export type UpdateMyProfileMutationBody = BodyType<UpdateProfileBody>;
export type UpdateMyProfileMutationError = ErrorType<void>;

/**
 * @summary Update current user profile
 */
export const useUpdateMyProfile = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyProfile>>,
    TError,
    { data: BodyType<UpdateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMyProfile>>,
  TError,
  { data: BodyType<UpdateProfileBody> },
  TContext
> => {
  return useMutation(getUpdateMyProfileMutationOptions(options));
};

/**
 * Generates a one-time deep link for the member to bind their Telegram account
 * @summary Initialize Telegram binding
 */
export const getInitTelegramBindUrl = () => {
  return `/api/members/me/telegram/init-bind`;
};

export const initTelegramBind = async (
  options?: RequestInit,
): Promise<TelegramBindLink> => {
  return customFetch<TelegramBindLink>(getInitTelegramBindUrl(), {
    ...options,
    method: "POST",
  });
};

export const getInitTelegramBindMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof initTelegramBind>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof initTelegramBind>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["initTelegramBind"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof initTelegramBind>>,
    void
  > = () => {
    return initTelegramBind(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InitTelegramBindMutationResult = NonNullable<
  Awaited<ReturnType<typeof initTelegramBind>>
>;

export type InitTelegramBindMutationError = ErrorType<void>;

/**
 * @summary Initialize Telegram binding
 */
export const useInitTelegramBind = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof initTelegramBind>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof initTelegramBind>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getInitTelegramBindMutationOptions(options));
};

/**
 * Verifies the HMAC signature from Telegram Login Widget and saves the telegram_id
 * @summary Verify Telegram Login Widget auth data
 */
export const getVerifyTelegramWidgetUrl = () => {
  return `/api/members/me/telegram/verify-widget`;
};

export const verifyTelegramWidget = async (
  telegramWidgetAuthData: TelegramWidgetAuthData,
  options?: RequestInit,
): Promise<MemberProfile> => {
  return customFetch<MemberProfile>(getVerifyTelegramWidgetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(telegramWidgetAuthData),
  });
};

export const getVerifyTelegramWidgetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyTelegramWidget>>,
    TError,
    { data: BodyType<TelegramWidgetAuthData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyTelegramWidget>>,
  TError,
  { data: BodyType<TelegramWidgetAuthData> },
  TContext
> => {
  const mutationKey = ["verifyTelegramWidget"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyTelegramWidget>>,
    { data: BodyType<TelegramWidgetAuthData> }
  > = (props) => {
    const { data } = props ?? {};

    return verifyTelegramWidget(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyTelegramWidgetMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyTelegramWidget>>
>;
export type VerifyTelegramWidgetMutationBody = BodyType<TelegramWidgetAuthData>;
export type VerifyTelegramWidgetMutationError = ErrorType<void>;

/**
 * @summary Verify Telegram Login Widget auth data
 */
export const useVerifyTelegramWidget = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyTelegramWidget>>,
    TError,
    { data: BodyType<TelegramWidgetAuthData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyTelegramWidget>>,
  TError,
  { data: BodyType<TelegramWidgetAuthData> },
  TContext
> => {
  return useMutation(getVerifyTelegramWidgetMutationOptions(options));
};

/**
 * Paid members submit their WhatsApp phone number to request access to the paid community. Sets the request status to "pending" until an admin confirms it.
 * @summary Register for the paid WhatsApp community
 */
export const getRegisterWhatsAppCommunityUrl = () => {
  return `/api/members/me/whatsapp/register`;
};

export const registerWhatsAppCommunity = async (
  whatsAppRegisterInput: WhatsAppRegisterInput,
  options?: RequestInit,
): Promise<MemberProfile> => {
  return customFetch<MemberProfile>(getRegisterWhatsAppCommunityUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(whatsAppRegisterInput),
  });
};

export const getRegisterWhatsAppCommunityMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerWhatsAppCommunity>>,
    TError,
    { data: BodyType<WhatsAppRegisterInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerWhatsAppCommunity>>,
  TError,
  { data: BodyType<WhatsAppRegisterInput> },
  TContext
> => {
  const mutationKey = ["registerWhatsAppCommunity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerWhatsAppCommunity>>,
    { data: BodyType<WhatsAppRegisterInput> }
  > = (props) => {
    const { data } = props ?? {};

    return registerWhatsAppCommunity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterWhatsAppCommunityMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerWhatsAppCommunity>>
>;
export type RegisterWhatsAppCommunityMutationBody =
  BodyType<WhatsAppRegisterInput>;
export type RegisterWhatsAppCommunityMutationError = ErrorType<void>;

/**
 * @summary Register for the paid WhatsApp community
 */
export const useRegisterWhatsAppCommunity = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerWhatsAppCommunity>>,
    TError,
    { data: BodyType<WhatsAppRegisterInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerWhatsAppCommunity>>,
  TError,
  { data: BodyType<WhatsAppRegisterInput> },
  TContext
> => {
  return useMutation(getRegisterWhatsAppCommunityMutationOptions(options));
};

/**
 * Returns the Telegram bot username for use with the Login Widget
 * @summary Get Telegram bot username
 */
export const getGetTelegramBotUsernameUrl = () => {
  return `/api/telegram/bot-username`;
};

export const getTelegramBotUsername = async (
  options?: RequestInit,
): Promise<TelegramBotUsernameResponse> => {
  return customFetch<TelegramBotUsernameResponse>(
    getGetTelegramBotUsernameUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTelegramBotUsernameQueryKey = () => {
  return [`/api/telegram/bot-username`] as const;
};

export const getGetTelegramBotUsernameQueryOptions = <
  TData = Awaited<ReturnType<typeof getTelegramBotUsername>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTelegramBotUsername>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTelegramBotUsernameQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTelegramBotUsername>>
  > = ({ signal }) => getTelegramBotUsername({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTelegramBotUsername>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTelegramBotUsernameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTelegramBotUsername>>
>;
export type GetTelegramBotUsernameQueryError = ErrorType<unknown>;

/**
 * @summary Get Telegram bot username
 */

export function useGetTelegramBotUsername<
  TData = Awaited<ReturnType<typeof getTelegramBotUsername>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTelegramBotUsername>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTelegramBotUsernameQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Sends a 6-digit OTP to the new email address to verify ownership
 * @summary Request notification email change
 */
export const getRequestNotificationEmailChangeUrl = () => {
  return `/api/members/me/notification-email/request`;
};

export const requestNotificationEmailChange = async (
  notificationEmailChangeInput: NotificationEmailChangeInput,
  options?: RequestInit,
): Promise<NotificationEmailOtpSent> => {
  return customFetch<NotificationEmailOtpSent>(
    getRequestNotificationEmailChangeUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(notificationEmailChangeInput),
    },
  );
};

export const getRequestNotificationEmailChangeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestNotificationEmailChange>>,
    TError,
    { data: BodyType<NotificationEmailChangeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestNotificationEmailChange>>,
  TError,
  { data: BodyType<NotificationEmailChangeInput> },
  TContext
> => {
  const mutationKey = ["requestNotificationEmailChange"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestNotificationEmailChange>>,
    { data: BodyType<NotificationEmailChangeInput> }
  > = (props) => {
    const { data } = props ?? {};

    return requestNotificationEmailChange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestNotificationEmailChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestNotificationEmailChange>>
>;
export type RequestNotificationEmailChangeMutationBody =
  BodyType<NotificationEmailChangeInput>;
export type RequestNotificationEmailChangeMutationError = ErrorType<void>;

/**
 * @summary Request notification email change
 */
export const useRequestNotificationEmailChange = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestNotificationEmailChange>>,
    TError,
    { data: BodyType<NotificationEmailChangeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestNotificationEmailChange>>,
  TError,
  { data: BodyType<NotificationEmailChangeInput> },
  TContext
> => {
  return useMutation(getRequestNotificationEmailChangeMutationOptions(options));
};

/**
 * Verifies the OTP and saves the new notification email address
 * @summary Verify notification email change
 */
export const getVerifyNotificationEmailChangeUrl = () => {
  return `/api/members/me/notification-email/verify`;
};

export const verifyNotificationEmailChange = async (
  notificationEmailVerifyInput: NotificationEmailVerifyInput,
  options?: RequestInit,
): Promise<NotificationPreferences> => {
  return customFetch<NotificationPreferences>(
    getVerifyNotificationEmailChangeUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(notificationEmailVerifyInput),
    },
  );
};

export const getVerifyNotificationEmailChangeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyNotificationEmailChange>>,
    TError,
    { data: BodyType<NotificationEmailVerifyInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyNotificationEmailChange>>,
  TError,
  { data: BodyType<NotificationEmailVerifyInput> },
  TContext
> => {
  const mutationKey = ["verifyNotificationEmailChange"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyNotificationEmailChange>>,
    { data: BodyType<NotificationEmailVerifyInput> }
  > = (props) => {
    const { data } = props ?? {};

    return verifyNotificationEmailChange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyNotificationEmailChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyNotificationEmailChange>>
>;
export type VerifyNotificationEmailChangeMutationBody =
  BodyType<NotificationEmailVerifyInput>;
export type VerifyNotificationEmailChangeMutationError = ErrorType<void>;

/**
 * @summary Verify notification email change
 */
export const useVerifyNotificationEmailChange = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyNotificationEmailChange>>,
    TError,
    { data: BodyType<NotificationEmailVerifyInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyNotificationEmailChange>>,
  TError,
  { data: BodyType<NotificationEmailVerifyInput> },
  TContext
> => {
  return useMutation(getVerifyNotificationEmailChangeMutationOptions(options));
};

/**
 * Returns the current user's email notification preferences
 * @summary Get notification preferences
 */
export const getGetMyNotificationPreferencesUrl = () => {
  return `/api/members/me/notifications`;
};

export const getMyNotificationPreferences = async (
  options?: RequestInit,
): Promise<NotificationPreferences> => {
  return customFetch<NotificationPreferences>(
    getGetMyNotificationPreferencesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetMyNotificationPreferencesQueryKey = () => {
  return [`/api/members/me/notifications`] as const;
};

export const getGetMyNotificationPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyNotificationPreferences>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyNotificationPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyNotificationPreferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyNotificationPreferences>>
  > = ({ signal }) =>
    getMyNotificationPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyNotificationPreferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyNotificationPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyNotificationPreferences>>
>;
export type GetMyNotificationPreferencesQueryError = ErrorType<void>;

/**
 * @summary Get notification preferences
 */

export function useGetMyNotificationPreferences<
  TData = Awaited<ReturnType<typeof getMyNotificationPreferences>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyNotificationPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyNotificationPreferencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update which categories trigger email notifications and the notification email address
 * @summary Update notification preferences
 */
export const getUpdateMyNotificationPreferencesUrl = () => {
  return `/api/members/me/notifications`;
};

export const updateMyNotificationPreferences = async (
  updateNotificationPreferencesBody: UpdateNotificationPreferencesBody,
  options?: RequestInit,
): Promise<NotificationPreferences> => {
  return customFetch<NotificationPreferences>(
    getUpdateMyNotificationPreferencesUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateNotificationPreferencesBody),
    },
  );
};

export const getUpdateMyNotificationPreferencesMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyNotificationPreferences>>,
    TError,
    { data: BodyType<UpdateNotificationPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyNotificationPreferences>>,
  TError,
  { data: BodyType<UpdateNotificationPreferencesBody> },
  TContext
> => {
  const mutationKey = ["updateMyNotificationPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyNotificationPreferences>>,
    { data: BodyType<UpdateNotificationPreferencesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyNotificationPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyNotificationPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyNotificationPreferences>>
>;
export type UpdateMyNotificationPreferencesMutationBody =
  BodyType<UpdateNotificationPreferencesBody>;
export type UpdateMyNotificationPreferencesMutationError = ErrorType<void>;

/**
 * @summary Update notification preferences
 */
export const useUpdateMyNotificationPreferences = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyNotificationPreferences>>,
    TError,
    { data: BodyType<UpdateNotificationPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMyNotificationPreferences>>,
  TError,
  { data: BodyType<UpdateNotificationPreferencesBody> },
  TContext
> => {
  return useMutation(
    getUpdateMyNotificationPreferencesMutationOptions(options),
  );
};

/**
 * Creates a Stripe checkout session for upgrading to paid membership
 * @summary Create Stripe checkout session
 */
export const getCreateCheckoutSessionUrl = () => {
  return `/api/subscriptions/create-checkout`;
};

export const createCheckoutSession = async (
  createCheckoutBody: CreateCheckoutBody,
  options?: RequestInit,
): Promise<CheckoutSessionResponse> => {
  return customFetch<CheckoutSessionResponse>(getCreateCheckoutSessionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCheckoutBody),
  });
};

export const getCreateCheckoutSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCheckoutSession>>,
    TError,
    { data: BodyType<CreateCheckoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCheckoutSession>>,
  TError,
  { data: BodyType<CreateCheckoutBody> },
  TContext
> => {
  const mutationKey = ["createCheckoutSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCheckoutSession>>,
    { data: BodyType<CreateCheckoutBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCheckoutSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCheckoutSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCheckoutSession>>
>;
export type CreateCheckoutSessionMutationBody = BodyType<CreateCheckoutBody>;
export type CreateCheckoutSessionMutationError = ErrorType<void>;

/**
 * @summary Create Stripe checkout session
 */
export const useCreateCheckoutSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCheckoutSession>>,
    TError,
    { data: BodyType<CreateCheckoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCheckoutSession>>,
  TError,
  { data: BodyType<CreateCheckoutBody> },
  TContext
> => {
  return useMutation(getCreateCheckoutSessionMutationOptions(options));
};

/**
 * Creates a Stripe billing portal session for managing subscriptions
 * @summary Create Stripe customer portal session
 */
export const getCreatePortalSessionUrl = () => {
  return `/api/subscriptions/portal`;
};

export const createPortalSession = async (
  options?: RequestInit,
): Promise<PortalSessionResponse> => {
  return customFetch<PortalSessionResponse>(getCreatePortalSessionUrl(), {
    ...options,
    method: "POST",
  });
};

export const getCreatePortalSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPortalSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPortalSession>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["createPortalSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPortalSession>>,
    void
  > = () => {
    return createPortalSession(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePortalSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPortalSession>>
>;

export type CreatePortalSessionMutationError = ErrorType<void>;

/**
 * @summary Create Stripe customer portal session
 */
export const useCreatePortalSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPortalSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPortalSession>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCreatePortalSessionMutationOptions(options));
};

/**
 * Handles incoming Stripe webhook events
 * @summary Stripe webhook handler
 */
export const getStripeWebhookUrl = () => {
  return `/api/subscriptions/webhook`;
};

export const stripeWebhook = async (options?: RequestInit): Promise<void> => {
  return customFetch<void>(getStripeWebhookUrl(), {
    ...options,
    method: "POST",
  });
};

export const getStripeWebhookMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stripeWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stripeWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["stripeWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stripeWebhook>>,
    void
  > = () => {
    return stripeWebhook(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StripeWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof stripeWebhook>>
>;

export type StripeWebhookMutationError = ErrorType<unknown>;

/**
 * @summary Stripe webhook handler
 */
export const useStripeWebhook = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stripeWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof stripeWebhook>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getStripeWebhookMutationOptions(options));
};

/**
 * Returns the most recently added tenders
 * @summary Get recent tenders
 */
export const getGetRecentTendersUrl = (params?: GetRecentTendersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/tenders/recent?${stringifiedParams}`
    : `/api/tenders/recent`;
};

export const getRecentTenders = async (
  params?: GetRecentTendersParams,
  options?: RequestInit,
): Promise<TenderSummary[]> => {
  return customFetch<TenderSummary[]>(getGetRecentTendersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetRecentTendersQueryKey = (
  params?: GetRecentTendersParams,
) => {
  return [`/api/tenders/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentTendersQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentTenders>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRecentTendersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentTenders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentTendersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentTenders>>
  > = ({ signal }) => getRecentTenders(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentTenders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecentTendersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentTenders>>
>;
export type GetRecentTendersQueryError = ErrorType<unknown>;

/**
 * @summary Get recent tenders
 */

export function useGetRecentTenders<
  TData = Awaited<ReturnType<typeof getRecentTenders>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRecentTendersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentTenders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecentTendersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns tenders closing within the next 7 days
 * @summary Get closing soon tenders
 */
export const getGetClosingSoonTendersUrl = () => {
  return `/api/tenders/closing-soon`;
};

export const getClosingSoonTenders = async (
  options?: RequestInit,
): Promise<TenderSummary[]> => {
  return customFetch<TenderSummary[]>(getGetClosingSoonTendersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetClosingSoonTendersQueryKey = () => {
  return [`/api/tenders/closing-soon`] as const;
};

export const getGetClosingSoonTendersQueryOptions = <
  TData = Awaited<ReturnType<typeof getClosingSoonTenders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getClosingSoonTenders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClosingSoonTendersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClosingSoonTenders>>
  > = ({ signal }) => getClosingSoonTenders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClosingSoonTenders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetClosingSoonTendersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClosingSoonTenders>>
>;
export type GetClosingSoonTendersQueryError = ErrorType<unknown>;

/**
 * @summary Get closing soon tenders
 */

export function useGetClosingSoonTenders<
  TData = Awaited<ReturnType<typeof getClosingSoonTenders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getClosingSoonTenders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetClosingSoonTendersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns 5 publicly visible tenders selected each week for promotional display
 * @summary Get weekly featured tenders
 */
export const getGetFeaturedTendersUrl = () => {
  return `/api/featured-tenders`;
};

export const getFeaturedTenders = async (
  options?: RequestInit,
): Promise<FeaturedTendersResponse> => {
  return customFetch<FeaturedTendersResponse>(getGetFeaturedTendersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetFeaturedTendersQueryKey = () => {
  return [`/api/featured-tenders`] as const;
};

export const getGetFeaturedTendersQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeaturedTenders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFeaturedTenders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeaturedTendersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeaturedTenders>>
  > = ({ signal }) => getFeaturedTenders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeaturedTenders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeaturedTendersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeaturedTenders>>
>;
export type GetFeaturedTendersQueryError = ErrorType<unknown>;

/**
 * @summary Get weekly featured tenders
 */

export function useGetFeaturedTenders<
  TData = Awaited<ReturnType<typeof getFeaturedTenders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFeaturedTenders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFeaturedTendersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
